import { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
    oneClient,
    getClient,
    storeClientPolicies,
    getClientTermsAndPrivacy,
    clientTermsAndPrivacy,
    clientDataStore,
} from '../../../../redux/slices/clientsSlice';
import { useParams } from 'react-router-dom';
import { Button, Radio, Space } from 'antd';
import { toast } from 'react-toastify';
import MultinationalTabs from '../../../../components/MultinationalTabs';
import {
    getPolicies,
    allPolicices,
} from '../../../../redux/slices/settingsSlice';
import StandartPrivacy from './StandartPrivacy';
import SpecificPrivacy from './SpecificPrivacy';
import { languagesOptions } from '../../../../shared/data/clientDetailsOptions';

export default function ClientPrivacySubPage() {
    const dispatch = useDispatch();
    const params = useParams();
    const client = useSelector(oneClient);
    const termsAndPrivacy = useSelector(clientTermsAndPrivacy);
    const policies = useSelector(allPolicices);
    const dataStore = useSelector(clientDataStore);

    const countriesLocalizationsData = useMemo(
        () =>
            termsAndPrivacy?.policy?.reduce((acc, el) => {
                acc[el.country_code] = { privacy_policy: el.privacy_policy };
                return acc;
            }, {}),
        [termsAndPrivacy],
    );

    const [excludedCodes, setExcludedCodes] = useState([]);
    const [data, setData] = useState({
        use_default_pp: 1,
        use_default_tc: 1,
        policies: {
            sv: {
                privacy_policy: '',
            },
            no: {
                privacy_policy: '',
            },
            fi: {
                privacy_policy: '',
            },
            da: {
                privacy_policy: '',
            },
            en: {
                privacy_policy: '',
            },
            is: {
                privacy_policy: '',
            },
        },
    });
    const [radioButtonValue, setRadioButtonValue] = useState('standart');

    useEffect(() => {
        dispatch(getPolicies());
    }, [dispatch]);

    useEffect(() => {
        setData({
            use_default_pp: termsAndPrivacy?.use_default_pp,
            use_default_tc: termsAndPrivacy?.use_default_tc,
            policies: {
                sv: {
                    privacy_policy:
                        countriesLocalizationsData?.sv?.privacy_policy,
                },
                no: {
                    privacy_policy:
                        countriesLocalizationsData?.no?.privacy_policy,
                },
                fi: {
                    privacy_policy:
                        countriesLocalizationsData?.fi?.privacy_policy,
                },
                da: {
                    privacy_policy:
                        countriesLocalizationsData?.da?.privacy_policy,
                },
                en: {
                    privacy_policy:
                        countriesLocalizationsData?.en?.privacy_policy,
                },
                is: {
                    privacy_policy:
                        countriesLocalizationsData?.is?.privacy_policy,
                },
            },
        });
        setRadioButtonValue(
            termsAndPrivacy?.use_default_pp ? 'standart' : 'specific',
        );
    }, [countriesLocalizationsData, termsAndPrivacy]);

    useEffect(() => {
        if (!!Object.keys(dataStore).length) {
            const excludedCodes = languagesOptions
                .filter((option) => option.id !== 'EN')
                .filter(
                    (option) =>
                        !dataStore?.account_languages?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
        }
    }, [dataStore]);

    const onRadioButtonsChange = (e) => {
        setRadioButtonValue(e.target.value);
        setData({
            ...data,
            use_default_pp: e.target.value === 'standart' ? 1 : 0,
        });
    };

    const onChangeMultinational = (text, flag) => {
        const newData = {
            ...data,
            policies: { ...data.policies, [flag]: { privacy_policy: text } },
        };

        setData(newData);
    };

    const onSaveSpecificPrivacy = async () => {
        try {
            await dispatch(
                storeClientPolicies({ id: params.id, body: data }),
            ).unwrap();
            toast.success('Changes saved successfully');
            dispatch(getClientTermsAndPrivacy(client.id));
            dispatch(getClient(client.id));
        } catch (error) {
            toast.error(error);
        }
    };

    const onSaveType = async () => {
        await dispatch(
            storeClientPolicies({ id: params.id, body: data }),
        ).unwrap();

        await dispatch(getClientTermsAndPrivacy(client.id)).unwrap();
        toast.success('Type of Terms of Use changed successfully');
    };

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Privacy Policy`}</title>
            </Helmet>
            <div className="terms-and-privacy-buttons__wrapper">
                <div className="form__item-wrapper--column">
                    <p className="input-label">What privacy policy?</p>
                    <Radio.Group
                        onChange={onRadioButtonsChange}
                        value={radioButtonValue}
                    >
                        <Space direction="horizontal">
                            <Radio value="standart">Standart</Radio>
                            <Radio value="specific">Partner specific</Radio>
                        </Space>
                    </Radio.Group>
                </div>
                <div>
                    <Button type="primary" size="large" onClick={onSaveType}>
                        <span>Save</span>
                    </Button>
                </div>
            </div>
            {radioButtonValue === 'standart' && (
                <MultinationalTabs excludedCodes={excludedCodes}>
                    <StandartPrivacy data={policies} />
                </MultinationalTabs>
            )}
            {radioButtonValue === 'specific' && (
                <SpecificPrivacy
                    data={data}
                    onChangeMultinational={onChangeMultinational}
                    excludedCodes={excludedCodes}
                    onSave={onSaveSpecificPrivacy}
                />
            )}
        </div>
    );
}
